import { httpService } from '../utils/http';
import {
  ApiResponse,
  Page,
  WxMerchantVO,
  WxMerchantQueryRequest,
  WxMerchantSaveRequest,
} from '../types';

class WxMerchantService {
  private readonly baseUrl = '/wxMerchant';

  getList(params: WxMerchantQueryRequest): Promise<ApiResponse<Page<WxMerchantVO>>> {
    return httpService.post(`${this.baseUrl}/list`, params);
  }

  save(params: WxMerchantSaveRequest): Promise<ApiResponse<WxMerchantVO>> {
    return httpService.post(`${this.baseUrl}/save`, params);
  }

  update(params: WxMerchantSaveRequest): Promise<ApiResponse<WxMerchantVO>> {
    return httpService.post(`${this.baseUrl}/update`, params);
  }

  delete(id: number): Promise<ApiResponse<null>> {
    return httpService.post(`${this.baseUrl}/delete`, { id });
  }
}

export const wxMerchantService = new WxMerchantService();
